import React, { useCallback } from "react";

export function useResetMFA(setMFA: React.Dispatch<boolean>) {
    const resetMFA = useCallback(() => {
        console.log("resetting mfa");
        setMFA(false);
    }, [setMFA]);

    return { resetMFA };
}